module.exports = __webpack_public_path__ + "static/img/equipmentu3.cfcf3407.webp";